module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-summary"
  }, [_c('div', {
    staticClass: "wrapper-btn-back",
    style: (("background-color:" + (_vm.globalColors.primary)))
  }, [_c('button', {
    staticClass: "account-summary-back",
    on: {
      "click": function($event) {
        _vm.$emit('close-modal')
      }
    }
  }, [_c('img', {
    staticClass: "arrow-back",
    attrs: {
      "src": "/static/img/arrow-back.svg",
      "alt": "ir hacia atras"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bold title-btn txt-center"
  }, [_vm._v("RESUMEN DE CUENTA")])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-list-item"
  }, [_c('div', {
    staticClass: "d-flex space-between align-center mb-2 btn-desktop"
  }, [_c('span', {
    staticClass: "account-summary-title bold",
    style: (("color:" + (_vm.globalColors.primary)))
  }, [_vm._v("RESUMEN DE CUENTA")]), _vm._v(" "), _c('button', {
    staticClass: "account-summary-btn",
    style: (("background-color:" + (_vm.globalColors.primary))),
    on: {
      "click": function($event) {
        _vm.goTo('edit-user-data')
      }
    }
  }, [_vm._v("Editar")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex wrap"
  }, [_c('div', {
    staticClass: "list-item flex-40"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Nombre:")]), _c('span', [_vm._v(" " + _vm._s(_vm.getUserInfo.name))])]), _vm._v(" "), _c('div', {
    staticClass: "list-item flex-40"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Apellido:")]), _c('span', [_vm._v(" " + _vm._s(_vm.getUserInfo.lastname))])]), _vm._v(" "), _c('div', {
    staticClass: "list-item flex-40"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Género:")]), _c('span', [_vm._v(" " + _vm._s(_vm.getGender))])]), _vm._v(" "), _c('div', {
    staticClass: "list-item flex-40"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.countryLabels.department) + ":")]), _c('span', [_vm._v(" " + _vm._s(_vm.department))])]), _vm._v(" "), _c('div', {
    staticClass: "list-item flex-40"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.countryLabels.province) + ": ")]), _c('span', [_vm._v(_vm._s(_vm.province))])]), _vm._v(" "), _c('div', {
    staticClass: "list-item flex-40"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Dirección:")]), _c('span', [_vm._v(" " + _vm._s(_vm.getUserInfo.address))])]), _vm._v(" "), _c('div', {
    staticClass: "list-item flex-40"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.countryLabels.district) + ":")]), _c('span', [_vm._v(" " + _vm._s(_vm.district))])]), _vm._v(" "), _c('div', {
    staticClass: "list-item flex-40"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.documentLabel) + ":")]), _c('span', [_vm._v(" " + _vm._s(_vm.getUserInfo.dni))])]), _vm._v(" "), _c('div', {
    staticClass: "list-item flex-40"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("RUC:")]), _c('span', [_vm._v(" " + _vm._s(_vm.getUserInfo.ruc))])]), _vm._v(" "), _c('div', {
    staticClass: "list-item flex-40"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Código Postal:")]), _vm._v(" " + _vm._s(_vm.getUserInfo.postalCode)), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "list-item flex-40"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Celular:")]), _c('span', [_vm._v(" " + _vm._s(_vm.setPhone))])]), _vm._v(" "), _c('div', {
    staticClass: "list-item flex-40"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Teléfono:")]), _c('span', [_vm._v(" " + _vm._s(_vm.getUserInfo.phone))])]), _vm._v(" "), _c('div', {
    staticClass: "list-item flex-40"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("E-mail:")]), _c('span', [_vm._v(" " + _vm._s(_vm.getUserInfo.email))])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-center align-center mb-2 btn-mobile"
  }, [_c('button', {
    staticClass: "account-summary-btn",
    style: (("background-color:" + (_vm.globalColors.primary))),
    on: {
      "click": function($event) {
        _vm.goTo('edit-user-data')
      }
    }
  }, [_vm._v("Editar")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b378551","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/account-summary.vue
// module id = 665
// module chunks = 9 20